





















































































































































































































































































































































































import {
  Component,
  Prop,
  Vue,
  Watch,
  ProvideReactive,
  Mixins
} from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import gtAttrSelect from "./attrValueSelect.vue";
import gtChooseAttr from "./chooseAttr.vue";
import skuMediaDialog from "./skuMediaDialog.vue";
import EditSkuDialog from "./editSkuDialog.vue";
import { prompt } from "@root/lib/utils";
import multiLangEnter from "@/components/pages/ProductCreate/multiLangEnter.vue";
import editPriceDialog from "@/components/pages/ProductCreate/editPriceDialog.vue";
import gtChannelList from "@/components/pages/ProductCreate/skuViewChannelCode.vue";
import skuImage from "@/components/pages/ProductCreate/skuImage.vue";
import {
  NumberRule,
  skuRule,
  skuNotRequiredRule,
  fomatLocaletoArray,
  skuExtCodeRequiredRule,
  skuNumberRule
} from "@root/lib/common";
import login from "../../../../../../views/Login.vue";
import { ProductChildren } from "@root/lib/mixins";
import { FormVaildateToOut } from "@root/lib/decorator";

const productCreate = namespace("productCreate");
const Root = namespace("root");
function attrRules() {
  return {
    "0": {
      required: true,
      trigger: "submit",
      message: this.$t("Basic.required_msg")
    },
    "1": {
      required: true,
      trigger: "submit",
      message: this.$t("Basic.required_msg")
    },
    "2": [
      {
        required: true,
        message: this.$t("Basic.required_msg"),
        trigger: "submit"
      },
      {
        max: 500,
        message: this.$t("Basic.required_500_char")
      }
    ],
    "21": [
      {
        required: true,
        validator: this.skuNameRuleValidator,
        trigger: "submit"
      }
    ]
  };
}

@Component({
  components: {
    gtAttrSelect,
    gtChooseAttr,
    EditSkuDialog,
    multiLangEnter,
    skuMediaDialog,
    editPriceDialog,
    gtChannelList,
    skuImage
  }
})
export default class sku extends Mixins(ProductChildren) {
  chooseAttrList = [];
  input1: string = "";
  loading: boolean = false;
  selectPicVisible: boolean = false;
  @productCreate.Getter skuList: any[];
  @productCreate.Getter propertiesData: any;
  @productCreate.Getter attrList: any[];
  @productCreate.Action batchEditSku: any;
  @productCreate.Action createProduct: any;
  @productCreate.Action updateProductStatus: any;
  @productCreate.Action queryProductInfo;
  @productCreate.Action querySkuChannelList;
  @productCreate.Action updateSkuStatus;
  @Root.State languageList;
  @productCreate.State productInfo;
  @productCreate.State familySkuList;
  @Root.State permission;

  attrValueData: any = {};
  deleteData: any = [];
  mediaData: any = {
    mediaLink: [],
    mobileMediaLink: []
  };
  ruleForm: any = {
    skuList: []
  };
  rules: any = {
    required: true,
    trigger: "blur"
  };
  attrRules: any = null;
  conditionList: any = [
    {
      key: "attrType",
      value: 2,
      type: 0
    }
  ];
  editData: any = null;
  editIndex: number = 0;
  NumberRule: any = null;
  skuRule: any = null;
  skuNotRequiredRule: any = null;
  onshelfSkuList = [];
  skuExtCodeRequiredRule: any = null;
  skuNumberRule: any = null;
  originForm = "";
  isChangeSku = false;
  isChangeSkuStatus = false;

  @Prop({ default: false })
  isEdit!: boolean;
  @Prop({ default: false }) readonly;

  @Prop({ default: false }) saveSkuSuccess: boolean;
  @Watch("saveSkuSuccess")
  async onSaveSkuSuccess(val: Array<any>) {
    if (val) {
      await this.changeProductStatus();
      this.$emit("skuChangeProductStatus");
    }
  }
  @Watch("attrList")
  onAttrListChange(val: Array<any>) {
    this.chooseAttrList = [...val];
  }
  @Watch("familySkuList")
  watchFamilySkuList(val: Array<any>) {
    if (val && !this.isEdit) {
      this.chooseAttrList = [...val];
    }
  }

  @Watch("skuList", { deep: true })
  onSkuListChange(val: Array<any>) {
    if (this.isEdit) {
      // this.ruleForm = {
      //   skuList: JSON.parse(JSON.stringify(val))
      // };
      this.originOnshelf();
      this.iniSkuLocales();
    }
  }

  @Watch("languageList")
  watchlanguageList(val) {
    this.iniSkuLocales();
  }
  @Watch("ruleForm.skuList", { deep: true })
  watchRuleFormSkuList(val) {
    if (this.originForm !== JSON.stringify(val)) {
      if (!this.isChangeSkuStatus) {
        this.isChangeSku = true;
      }
    } else {
      this.isChangeSku = false;
    }
    this.$emit("isChangeSku", this.isChangeSku);
    this.isChangeSkuStatus = false;
  }
  curLocale = localStorage.getItem("localeLanguage");
  iniSkuLocales() {
    if (this.languageList.length <= 0 && this.ruleForm.skuList.length <= 0) {
      return;
    }
    this.initLangItem();
    this.ruleForm.skuList.forEach(item => {
      let { extendParams } = item;
      let allObj = extendParams ? JSON.parse(extendParams) : {};
      let cur = allObj["skuName"];
      let obj = {};
      if (!item.multiSkuAttr) {
        this.$set(item, "multiSkuAttr", {});
      }
      this.attrList.forEach(({ attrValueType, attrCode }) => {
        if (attrValueType === 2) {
          if (allObj[attrCode] && allObj[attrCode]["[AC]"]) {
            this.$set(item.multiSkuAttr, attrCode, {
              ...this.initLangObj,
              ...allObj[attrCode]["[AC]"]
            });
          } else {
            this.$set(item.multiSkuAttr, attrCode, { ...this.initLangObj });
          }
        }
      });
      if (cur && cur["[AC]"] && Object.keys(cur["[AC]"]).length > 0) {
        obj = cur["[AC]"];
      }
      this.$set(item, "skuNameLocales", { ...this.initLangObj, ...obj });
      if (!item.skuNameLocales[this.curLocale]) {
        this.$set(item.skuNameLocales, this.curLocale, item.skuName);
      }
    });
    this.originForm = JSON.stringify(this.ruleForm.skuList);
  }

  created() {
    // 绑定验证规则
    this.attrRules = attrRules.apply(this);
    this.NumberRule = NumberRule.bind(this);
    this.skuRule = skuRule.bind(this);
    this.skuNotRequiredRule = skuNotRequiredRule.bind(this);
    this.skuExtCodeRequiredRule = skuExtCodeRequiredRule.bind(this);
    this.skuNumberRule = skuNumberRule.bind(this);
  }
  mounted() {
    if (this.isEdit) {
      this.ruleForm.skuList = JSON.parse(JSON.stringify(this.skuList));
      this.iniSkuLocales();
    }
  }
  originOnshelf() {
    this.onshelfSkuList = this.ruleForm.skuList.map(_ => {
      if (_.status === 1) {
        return _.skuCode;
      }
    });
  }
  async changeProductStatus() {
    let message: any = this.$t("Basic.success");
    //  检测当前商品是否上架，如果未上架，且操作了上架sku 的动作，弹出层提示是否要上架该商品
    if (this.propertiesData.status === 0) {
      let addNewSkuOnShelf = this.ruleForm.skuList.some(_ => {
        return _.statusTemp && !this.onshelfSkuList.includes(_.skuCode);
      });
      if (addNewSkuOnShelf) {
        prompt
          .call(this, {
            message: this.$t("Product.list_product"),
            confirmButtonText: this.$t("Basic.ok")
          })
          .then(async () => {
            await this.updateProductStatus({
              productCode: this.propertiesData.productCode,
              status: 1
            });
            this["$message"].success(message);
            this.queryProductInfo(this.propertiesData.productCode);
          })
          .catch(error => {
            console.log(error);
          });
      }
    }
  }
  handleSelectAttr(data: any): void {
    data.forEach((cell: any) => {
      let attr: any = {};
      attr[cell.attrCode] = [{ attrValue: "" }];
      this.ruleForm.skuList.forEach((item: any) => {
        item.relatedAttrValue = {
          ...item.relatedAttrValue,
          ...attr
        };
        if (cell.attrIsLanguage) {
          this.$set(item.multiSkuAttr, cell.attrCode, { ...this.initLangObj });
        }
      });
    });
    this.ruleForm = JSON.parse(JSON.stringify(this.ruleForm));
    this.chooseAttrList = [...this.chooseAttrList, ...data];
  }
  handleAddAttr(): void {
    const $chooseAttr: any = this.$refs.chooseAttr;
    $chooseAttr.visible = true;
  }
  handleDelAttr(item, index: number): void {
    let message: any = this.$t("Basic.confirm_delete"),
      title: any = this.$t("Basic.Warning");
    this["$confirm"](message, title).then(res => {
      if (res) {
        this.chooseAttrList.splice(index, 1);
        // 删除该属性z
        this.ruleForm.skuList.forEach(sku => {
          let { [item.attrCode]: curAttr, ...other } = sku.relatedAttrValue;
          sku.relatedAttrValue = other;
          if (item.attrIsLanguage) {
            let { [item.attrCode]: curMul, ...otherMul } = sku.multiSkuAttr;
            sku.multiSkuAttr = otherMul;
          }
        });
      }
    });
  }
  isAddSku = true;
  handleAddSku(): void {
    this.isAddSku = true;
    (this.$refs.editSKUDialog as any).visible = true;
    this.curEditSku = {
      skuCode: "",
      skuNo: "",
      skuName: "",
      extCode: "",
      barcode: "",
      orgCode: "default",
      productPrice: "",
      productCode: (this.skuList.length && this.skuList[0].productCode) || "",
      salePrice: "",
      mediaLink: "",
      mobileMediaLink: "",
      statusTemp: this.permission.PIM_SKU_ON_BUTTON ? true : false,
      skuNameLocales: { ...this.initLangObj },
      ...this.getRelatedAttrValue()
    };
  }

  getRelatedAttrValue(): any {
    let relatedAttrValue: any = {};
    let multiSkuAttr = {};
    this.chooseAttrList.forEach((item: any) => {
      relatedAttrValue[item.attrCode] = [
        {
          attrValue: ""
        }
      ];
      if (item.attrValueType === 2 && item.attrIsLanguage === 1) {
        multiSkuAttr[item.attrCode] = { ...this.initLangObj };
      }
    });
    return { relatedAttrValue, multiSkuAttr };
  }

  handleDelete(row, index: number): void {
    let code = row.skuCode;
    // let message: any = this.$t("Basic.confirm_delete"),
    //   title: any = this.$t("Basic.Warning");
    // this["$confirm"](message, title).then(res => {
    //   if (res) {
    const delData = this.skuList.find((item: any) => item.skuCode === code);
    delData &&
      this.deleteData.push({
        ...this.ruleForm.skuList[index],
        logicDelete: 1
      });
    this.ruleForm.skuList.splice(index, 1);
    //   }
    // });
  }
  curSku = "";
  // 编辑productName多语言
  curEditSku: any = {};
  curEditAttrCode = "";
  isAllMultiLang(item) {
    return this.languageList.every(_ => {
      let value = item ? item[_.value] : "";
      return !!value;
    });
  }
  initLangObj = {};
  initLangItem() {
    this.languageList.forEach((_, index) => {
      if (!this.initLangObj[_.value]) {
        this.$set(this.initLangObj, _.value, "");
      }
    });
  }
  skuNameRuleValidator(rule, value, callback) {
    let all = this.isAllMultiLang(value);
    if (!value || !all) {
      let info: any = this.$t("Basic.required_msg");
      callback(new Error(info));
    }
    callback();
  }
  isMultiLangAttr(item) {
    return !!(item.attrValueType === 2 && item.attrIsLanguage);
  }
  skuProp(item) {
    return this.isMultiLangAttr(item)
      ? `.multiSkuAttr.${item.attrCode}`
      : `.relatedAttrValue.${item.attrCode}.0.attrValue`;
  }
  curEditSkuIndex: any = "";
  handleEdit(row, index) {
    this.isAddSku = false;
    this.curEditSku = { ...row };
    this.curEditSkuIndex = index;
    (this.$refs.editSKUDialog as any).visible = true;
  }
  editSkuConfirm(data) {
    if (!this.isAddSku) {
      this.curEditSku = {};
      this.$set(this.ruleForm.skuList, this.curEditSkuIndex, { ...data });
    } else {
      this.ruleForm.skuList.push({ ...data });
    }
  }
  mediaTab = "spu";
  openMediaDialog(tab, row, index) {
    this.mediaTab = tab;
    this.curEditSkuIndex = index;

    this.mediaData = {
      mediaLink: row.mediaLink ? row.mediaLink.split(",") : [],
      mobileMediaLink: row.mobileMediaLink ? row.mobileMediaLink.split(",") : []
    };
    (this.$refs.skuMediaDialog as any).visible = true;
  }
  changeSkuMedia(data) {
    this.ruleForm.skuList[this.curEditSkuIndex].mediaLink = data.mediaLink;
    this.ruleForm.skuList[this.curEditSkuIndex].mobileMediaLink =
      data.mobileMediaLink;
  }
  handleVaildate() {
    return new Promise((resolve, reject) => {
      if (this.ruleForm.skuList.length === 0) {
        let message: any = this.$t("Product.sku_empty");
        this["$message"].error(message);
        reject();
      } else {
        (this.$refs["form"] as any).validate(vaild => {
          if (vaild) {
            console.log(765, this.ruleForm.skuList);

            let res = this.resFormart();
            resolve(res);
          } else {
            reject();
          }
        });
      }
    });
  }
  resFormart() {
    const sku = [...this.ruleForm.skuList, ...this.deleteData].map(
      (item: any) => {
        const relatedAttrValue = Object.keys(item.relatedAttrValue || {}).map(
          (cell: any) => {
            let attrDetails = this.chooseAttrList.filter(
              _ => _.attrCode === cell
            );
            let selfAttr = attrDetails.length ? attrDetails[0] : {};
            const vaule = item.relatedAttrValue[cell];
            let attrValueList = [];
            if (vaule[0].attrValue instanceof Array) {
              attrValueList = vaule[0].attrValue.map(
                (el: any) => (el = { attrValue: el })
              );
            } else {
              let result = vaule[0].attrValue;
              // 只有text 属性才去保存多语言
              if (
                selfAttr.attrValueType === 2 &&
                selfAttr.attrIsLanguage &&
                item.multiSkuAttr[cell]
              ) {
                result = item.multiSkuAttr[cell][this.curLocale];
              }
              attrValueList = [{ attrValue: result }];
            }
            const chooseAttrList = this.chooseAttrList.map(
              (item: any) => item.attrCode
            );
            //is Delete 如果删除了attr 需要将 attr 的 logicDelete 字段设为1?
            const logicDelete = Number(
              !chooseAttrList.includes(cell)
            ).toString();
            if (!chooseAttrList.includes(cell)) {
              delete item.multiSkuAttr[cell];
            }
            return {
              attrCode: cell,
              logicDelete,
              attrValueList: attrValueList
            };
          }
        );
        let localeList = [];
        this.chooseAttrList.forEach(element => {
          if (this.isMultiLangAttr(element)) {
            localeList = [
              ...localeList,
              ...fomatLocaletoArray(
                this.languageList,
                item.multiSkuAttr[element.attrCode],
                element.attrCode
              )
            ];
          }
        });
        let result = {
          ...item,
          relatedAttrValue,
          localeList: [
            ...localeList,
            ...fomatLocaletoArray(
              this.languageList,
              item.skuNameLocales,
              "skuName"
            )
          ],
          status: item.statusTemp ? 1 : 0,
          productCode: this.propertiesData.productCode,
          skuName: item.skuNameLocales[this.curLocale]
        };
        delete result.skuNameLocales;
        delete result.extendParams;
        delete result.multiSkuAttr;
        delete result.statusTemp;
        return result;
      }
    );

    return { skuList: sku };
  }
  changePrice(price, type, index) {
    this.ruleForm.skuList[index][type] = Number(price);
  }

  get viewMoreList() {
    return [
      { text: this.$t("Product.viewChannel"), command: "handleViewChannel" }
    ];
  }
  // -- view more
  handleMoreCommand(command, scope) {
    this[command] && this[command](scope.row, scope.$index);
  }
  skuChannelList = [];
  async handleViewChannel(row) {
    this.curSku = row.skuCode;
    this.skuChannelList = await this.querySkuChannelList(row.skuCode);
    let dialog: any = this.$refs.dialogChannelList;
    dialog.visibleChannel = true;
  }

  getSkuImgs(keyCode, row) {
    return row[keyCode] ? row[keyCode].split(",") : "";
  }
  async updateSkuStatusFn(row) {
    if (row.skuCode) {
      await this.updateSkuStatus({
        skuCode: row.skuCode,
        status: row.statusTemp ? 0 : 1
      });
      this.isChangeSkuStatus = true;
      row.statusTemp = !row.statusTemp;
      row.status = row.statusTemp ? 1 : 0;
      let message: any = this.$t("Basic.success");
      this["$message"].success(message);
    } else {
      row.statusTemp = !row.statusTemp;
      row.status = row.statusTemp ? 1 : 0;
    }
  }
}
